export interface BrandCheckName {
  name: string;
  shortName: string;
  nameErrors: string[];
  shortNameErrors: string[];
}
